
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 0h8c.971 0 1.834.461 2.383 1.177L17.542 6.5l-4.16 5.323A2.996 2.996 0 0111 13H3a3 3 0 01-3-3V3a3 3 0 013-3zm9.578 11.23l3.695-4.73-3.695-4.73-.002-.001A1.996 1.996 0 0011 1H3a2 2 0 00-2 2v7a2 2 0 002 2h8c.64 0 1.21-.3 1.576-.769l.002-.002v.001z","fill":"#000"}})])
          )
        }
      }
    